import React, { useEffect, useRef, useState } from "react";

const PasswordReset = ({ title, text, setShowPopup }) => {
  const [email, setEmail] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const popupRef = useRef(null);

  const handleResetPassword = async () => {
    setLoading(true);
    const apiUrl = `/dial-api/encalm/login/${email}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      // console.log("password reset data", result);
      if (result.message === "success") {
        setResetSuccess(true);
        setLoading(false);
      } else {
        // todo with error response
      }
    } catch (error) {
      console.error("Error calling API:", error);
      setLoading(false);
      throw error;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowPopup]);
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-20">
      <div
        ref={popupRef}
        className=" w-[90%] xl:w-[70%] bg-white p-[6vw] xl:p-[3vw] rounded-lg shadow-lg text-center"
      >
        <h2 className="font-redhatMedium text-[3.5vw] text-primary md:text-[2vw] xl:text-[1.5vw] text-left py-[0.8vw] xl:py-[0.5vw] mb-[2vw] xl:mb-[1vw] border-b border-primary">
          Enter Your Email
        </h2>
        {resetSuccess ? (
          <div>
            <p className="font-redhatRegular text-[3.5vw] text-primary md:text-[2vw] xl:text-[1.5vw] mb-[0.5vw]">Thank You</p>
            <p className="font-redhatRegular text-[3.5vw] text-primary md:text-[2vw] xl:text-[1.5vw] mb-[0.5vw]">Your password has been reset successfully & sent on your registered email id!</p>
            <p className="font-redhatRegular text-[3.5vw] text-primary md:text-[2vw] xl:text-[1.5vw] mb-[0.5vw]">Your password has been reset successfully, please check your mail for new password.</p>
            <button onClick={() => setShowPopup(false)} className="mt-[3vw] px-[2.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] bg-primary text-white rounded">Ok</button>
          </div>
        ) : (
          <div>
            <div>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Enter Your Email"
                className="w-[100%] xl:w-[55%] border border-[#CACACA] font-redhatRegular text-primary text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw] px-[3vw] md:px-[2vw] xl:px-[1vw] py-[2vw] md:py-[1vw] xl:py-[0.5vw] rounded outline-none"
              />
            </div>
            <button
              onClick={handleResetPassword}
              className="mt-[3vw] px-[2.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] bg-primary text-white rounded"
            >
              {loading ? "Please Wait..." : "Reset Password"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordReset;
